import React from 'react';
import TabsTable from './TabsTable';
import Table from './Table';
import OmDataTable from './dataTable';

const Tables = ({ tableContent }) => {
    
    if (!tableContent)
        return '';
    
    if (process.env.GATSBY_COUNTRY_SELECTOR === 'ut' && tableContent.__typename === 'Contentstack_table')
        return <OmDataTable {...tableContent} />

    if (tableContent.__typename === 'Contentstack_table')
        return <Table tableContent={tableContent} />

    
    if (tableContent.__typename === 'Contentstack_tabs_table')
        return <TabsTable tabsTable={tableContent} />

    return ''
}

export default Tables;